import type {
	DashboardListVariable,
	DashboardVariable,
	DashboardVariableSpec,
} from "../../../../common/dashboard-spec";

import { type DynamicListVariable, isDynamicListVariable } from "./dynamic-list-variable";

// An AsyncRead variable is a variable whose query we need to run to discover its true value
export type AsyncReadVariable = DynamicListVariable & {
	readonly spec: DashboardVariableSpec & {
		readonly spec: DashboardListVariable & {
			customAllValue: undefined;
			defaultValue: Extract<DashboardListVariable["defaultValue"], { type: "Everything" }>;
		};
	};
};

export function isAsyncReadVariable(variable: DashboardVariable): variable is AsyncReadVariable {
	return (
		isDynamicListVariable(variable) &&
		variable.spec.spec.customAllValue == null &&
		variable.spec.spec.defaultValue?.type === "Everything"
	);
}
